import { writable } from 'svelte/store'

export const pageSettingsStore = writable({
  zenMode: false,
})

export function getPageSettingsStore() {
  return pageSettingsStore
}
